import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import LogSection from "../components/LogSection/LogSection"

const IndexPage = props => {
  const { data } = props

  return (
    <Layout>
      <SEO title="Home" />
      <LogSection logs={data.logSection.nodes[0].frontmatter.logs} />
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query IndexPageQuery {
    ...LogCardSectionFragment
  }
`
